import { SVGProps } from "react";

export default function SecureWallet(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={props.width ? props.width : "24"}
      height={props.height ? props.height : "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M15 11.75C14.59 11.75 14.25 11.41 14.25 11V10C14.25 8.54 13.89 7.75 12 7.75C10.11 7.75 9.75 8.54 9.75 10V11C9.75 11.41 9.41 11.75 9 11.75C8.59 11.75 8.25 11.41 8.25 11V10C8.25 9.07 8.25 6.25 12 6.25C15.75 6.25 15.75 9.07 15.75 10V11C15.75 11.41 15.41 11.75 15 11.75Z"
        fill="white"
      />
      <path
        d="M11.9999 15.3484C11.2599 15.3484 10.6499 14.7384 10.6499 13.9984C10.6499 13.2584 11.2599 12.6484 11.9999 12.6484C12.7399 12.6484 13.3499 13.2584 13.3499 13.9984C13.3499 14.7384 12.7399 15.3484 11.9999 15.3484ZM11.9999 13.8484C11.9199 13.8484 11.8499 13.9184 11.8499 13.9984C11.8499 14.1684 12.1499 14.1684 12.1499 13.9984C12.1499 13.9184 12.0799 13.8484 11.9999 13.8484Z"
        fill="white"
      />
      <path
        d="M14.5 17.75H9.5C7.1 17.75 6.25 16.9 6.25 14.5V13.5C6.25 11.1 7.1 10.25 9.5 10.25H14.5C16.9 10.25 17.75 11.1 17.75 13.5V14.5C17.75 16.9 16.9 17.75 14.5 17.75ZM9.5 11.75C7.91 11.75 7.75 11.91 7.75 13.5V14.5C7.75 16.09 7.91 16.25 9.5 16.25H14.5C16.09 16.25 16.25 16.09 16.25 14.5V13.5C16.25 11.91 16.09 11.75 14.5 11.75H9.5Z"
        fill="white"
      />
      <path
        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
        fill="white"
      />
    </svg>
  );
}
